import React from 'react';
import { ICON_MAP, ICON_NAMES } from '@/lib/iconMap';

/**
 * Text input for a Lucide icon name, with a datalist of valid names and a live
 * preview of the resolved icon. Use when editing `icon` fields.
 */
export default function IconPickerInput({ value, onChange, className, placeholder }) {
  const listId = React.useId();
  const Icon = typeof value === 'string' && ICON_MAP[value] ? ICON_MAP[value] : null;
  return (
    <div className="flex items-center gap-2">
      <div className="relative flex-1">
        <input
          type="text"
          list={listId}
          value={value ?? ''}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder || 'Lucide icon name'}
          className={className}
        />
        <datalist id={listId}>
          {ICON_NAMES.map((n) => (
            <option key={n} value={n} />
          ))}
        </datalist>
      </div>
      <div className="flex-shrink-0 w-9 h-9 rounded-lg border border-slate-200 bg-slate-50 flex items-center justify-center text-slate-600">
        {Icon ? <Icon className="w-5 h-5" /> : <span className="text-[10px] text-slate-300">—</span>}
      </div>
    </div>
  );
}